(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phantom-affiliate-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.phantom-affiliate-form')) return;
    event.preventDefault();
    const button = form.querySelector('button');
    const result = form.querySelector('.phantom-affiliate-result');
    button.disabled = true;
    result.textContent = '';
    try {
      const response = await fetch(form.action, {method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}});
      const data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.message);
      result.textContent = data.message;
      form.reset();
    } catch (error) {
      result.textContent = error.message || 'Your application could not be submitted. Please try again.';
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
